enum WorkspaceMilestonePaymentStatus {
  none = 'none',
  pending = 'pending',
  inProgress = 'in_progress',
  completed = 'completed',
  released = 'released',
  failed = 'failed',
}

export default WorkspaceMilestonePaymentStatus
